import api from "../axios/api";
import { IPayload } from "../models/ipayload";
import Axios from "axios";
import { ICompany } from "../models/icompany";
let CancelToken = Axios.CancelToken;
let fetchCompanies_cancel: any;


export const fetchCompaniesService = (page: number, limit: number, search: string, order: string, orderBy: string): Promise<IPayload<ICompany>> => {
  fetchCompanies_cancel && fetchCompanies_cancel()

  const queryParams = `?page=${!page || page < 1 ? 1 : page}&limit=${!limit || limit < 5 ? 5 : limit}&q=${search ? search : ''}&sort=${order === 'desc' ? '-' : ''}${orderBy}`;
  return api.get('/companies' + queryParams, {
    cancelToken: new CancelToken(function executor(c) {
      fetchCompanies_cancel = c;
    })
  })
}


